import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

export const deleteTeam = async (teamId: string) => {
  const url = `${apiUrl}deleteTeam/`;
  const requestBody = {
    TeamUUID: teamId,
  };
  try {
    const response = await postWithAuth(url, requestBody);
    const data = JSON.parse(await response.json());
    return data;
  } catch (error) {
    console.error('Error deleting team:', error);
    return { Error: 'Error deleting team' };
  }
};
